import { useCallback, useEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { createHook, createStore } from '@atlassian/react-sweet-state';
import { type Actions, actions as subscriberActions } from './actions';
import type { State } from './types';

export const initialState: State = {
	opsgenieBaseUrl: undefined,
	fetchStatus: undefined,
	error: undefined,
};

const opsgenieBaseUrlStore = createStore<State, Actions>({
	name: 'opsgenieBaseUrl',
	initialState,
	actions: subscriberActions,
});

export const useOpsgenieBaseUrlInternal = createHook(opsgenieBaseUrlStore);

export const useOpsgenieBaseUrl = (packageName: string) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [state, { fetchOpsgenieBaseUrl }] = useOpsgenieBaseUrlInternal();

	const fetchOgBaseUrl = useCallback(
		() => fetchOpsgenieBaseUrl(createAnalyticsEvent({}), packageName),
		[createAnalyticsEvent, fetchOpsgenieBaseUrl, packageName],
	);

	useEffect(() => {
		if (state.opsgenieBaseUrl === undefined && !state.fetchStatus) {
			fetchOgBaseUrl();
		}
	}, [fetchOgBaseUrl, state.opsgenieBaseUrl, state.fetchStatus]);

	return [state, { fetchOgBaseUrl }] as const;
};
